module.exports = __webpack_public_path__ + "img/06.rainyday-light.6e2d09ee.svg";